import balanceText from 'balance-text';
import Alpine from 'alpinejs';
import focus from '@alpinejs/focus';
import collapse from '@alpinejs/collapse';
import intersect from '@alpinejs/intersect';
import CareersSearch from '../theme/templates/components/careers-search-map/careers-search-map.js';
import LocationsMap from '../theme/templates/components/locations-map/locations-map.js';
import PeopleDirectory from '../theme/templates/components/people-directory/people-directory.js';
import compCalc from '../theme/templates/components/calculator-loan/comp-calc.js';
import compCalcHM from '../theme/templates/components/calculator-loan/comp-calc-hm.js';
import emAppCalc from '../theme/templates/components/calculator-loan/em-app-calc.js';
import criticalCareCalc from '../theme/templates/components/calculator-loan/critical-care-calc.js';
import AreaMap from '../theme/templates/components/area-map/area-map.js';

// https://alpinejs.dev/globals/alpine-data#registering-from-a-bundle
document.addEventListener('alpine:init', () => {
  balanceText();
  Alpine.store('darkNav', false);
  Alpine.store('bannerVisible', false);
  Alpine.store('bannerHeight', 0);
  Alpine.store('serviceWheelScriptLoaded', 0);
  Alpine.data('CareersSearch', CareersSearch);
  Alpine.data('LocationsMap', LocationsMap);
  Alpine.data('PeopleDirectory', PeopleDirectory);
  Alpine.data('compCalc', compCalc);
  Alpine.data('compCalcHM', compCalcHM);
  Alpine.data('emAppCalc', emAppCalc);
  Alpine.data('criticalCareCalc', criticalCareCalc);
  Alpine.data('AreaMap', AreaMap);
});

Alpine.plugin(collapse);
Alpine.plugin(focus);
Alpine.plugin(intersect);
window.Alpine = Alpine;
Alpine.start();
